import isBrowser from '../../../utils/isBrowser';
var isOnline = function () {
    if (isBrowser && typeof navigator.onLine !== 'undefined') {
        return navigator.onLine;
    }
    return true;
};
export default isOnline;
//# sourceMappingURL=isOnline.js.map